// External Dependencies
import classNames from 'classnames';

import { BoxProps } from './Box';
import Flex from './Flex';

// Local Typings
export interface ThreeEvenElementsProps extends BoxProps {
  centerElement?: React.ReactNode;
  leftElement?: React.ReactNode;
  rightElement?: React.ReactNode;
}

const ThreeEvenElements: React.FC<ThreeEvenElementsProps> = ({
  centerElement,
  leftElement,
  rightElement,
  ...props
}) => {
  return (
    <Flex
      fullWidth
      justifyContent="center"
      {...props}
      className={classNames(props.className, 'three-even-elements')}
    >
      <Flex flex="1">
        {leftElement}
      </Flex>

      {centerElement}

      <Flex
        flex="1"
        justifyContent="flex-end"
      >
        {rightElement}
      </Flex>
    </Flex>

  );
};

export default ThreeEvenElements;
